<div class="row">
  <div class="col-12">

    <div id="missingUsernameAndOtpError" *ngIf="missingUsernameAndOtpAlertShown" class="alert alert-danger mb-4 py-4" role="alert">
      <p>This page lacks username and one time password information.</p>
      <span class="alert-span">To reset your password, please navigate to
        <a href="" [routerLink]="'/trouble-signing-in'">Trouble Signing In page</a>.</span>
    </div>

    <div id="genericErrorAlert" class="alert alert-danger mb-4 py-4" role="alert" *ngIf="genericErrorAlertShown"
         [@showGenericErrorAlert]>
      <p>We encountered an issue completing your request.</p>
      <span class="alert-span">Please try again later or contact Customer Service at {{ customerServicePhone }}.</span>
    </div>

    <div id="blacklistedPasswordErrorAlert" class="alert alert-danger mb-4 py-4" role="alert" *ngIf="blacklistedPasswordErrorAlertShown"
         [@showBlacklistedPasswordAlert]>
      <p>We encountered an issue completing your request.</p>
      <span class="alert-span">Password cannot contain your Username, First Name, Last Name, or other Blacklisted terms. Please enter a new password, and try again.</span>
    </div>

    <form id="resetPasswordForm" [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPasswordForm()">

      <div class="form-group form-label-group">
        <input id="passwordInput" formControlName="passwordInput" type="password" class="form-control"
               placeholder="New Password"
               [ngClass]="{ 'is-invalid': resetPasswordFormSubmitted && resetPasswordForm.controls.passwordInput.errors }">
        <label for="passwordInput">New Password</label>
        <span class="password-help" data-toggle="password-modal">
          <small id="passwordHelp" class="form-text text-muted">Please enter and confirm your password. View our <a data-toggle="modal" href="#password-modal">Password Guidelines</a> for more details.</small>
        </span>

        <div id="password-modal" class="modal fade bd-example-modal-md" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Security Guidelines for a Safe Password</h4>
              </div>
              <div class="modal-body">
                <ul>
                  <li>Don't include personal information (First name, Last name, Birth date, etc.)</li><br>
                  <li>Make sure your Username and Password are different</li><br>
                  <li>Change your password often</li><br>
                  <li>Make sure your new password isn't the same as your last 24 passwords</li><br>
                  <li>Never share your password with anyone</li><br>
                  <li>Never write your password down or email it to anyone</li><br>
                  <li>For security reasons, your password must include one of the following special characters: ~, !, @, #, $, %, ^, &, *, (, ), [, {{'{'}}, }</li><br>
                  <li class="secondary-list">For security reasons, your password may not use: <br> <br>
                    <p>- Abbreviated months or days of the week, like JAN, OCT, MON or TUE</p>
                    <p>- Repeating letters or numbers, like aaa111</p>
                    <p>- Letters or numbers in order, like abc123</p>
                    <p>- More than 5 numbers next to each other</p>
                    <p>- Special words, SYS, LOG, TSO, PAS, NEW, NET, ROS, XXX, SIGN, VTAM, DEMO, ASDF, 1234, BASIC, FOCUS, CADAM, VALID, GAME, IL1, TX1, OK1, NM1, MT1, DG1, SB1 and APPL</p>
                  </li>
                </ul>
              </div>
              <div class="modal-footer">
                <button class="btn btn-primary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="resetPasswordFormSubmitted && formControls.passwordInput.errors" class="invalid-feedback">
          <div *ngIf="formControls.passwordInput.errors.required">A new password is required.</div>
          <div *ngIf="formControls.passwordInput.errors.oldPasswordValue">Your new password must not be the same as your last password.</div>
          <div *ngIf="formControls.passwordInput.errors.minlength">Your new password must be at least 8 symbols long.</div>
          <div *ngIf="formControls.passwordInput.errors.maxlength">Your new password must not be longer than 40 symbols.</div>
          <div *ngIf="!formControls.passwordInput.errors.minlength && !formControls.passwordInput.errors.maxlength &&
              formControls.passwordInput.errors.pattern">
            Your new password must include:<br>
            <div *ngIf="formControls.passwordInput.errors.atLeastOneLowerCaseCharacter">
              - At least 1 lower case character.<br></div>
            <div *ngIf="formControls.passwordInput.errors.atLeastOneUpperCaseCharacter">
              - At least 1 upper case character.<br></div>
            <div *ngIf="formControls.passwordInput.errors.atLeastOneDigit">
              - At least 1 digit.<br></div>
            <div *ngIf="formControls.passwordInput.errors.atLeastOneSpecialCharacter">
              - At least 1 special character: ~, !, @, #, $, %, ^, &, *, (, ), [, {{'{'}}, }</div>
          </div>
          <div *ngIf="!formControls.passwordInput.errors.minlength && !formControls.passwordInput.errors.maxlength &&
            !formControls.passwordInput.errors.pattern && formControls.passwordInput.errors.repeatingChars">
            Your new password must not contain more than 2 repeating characters in a row - e.g. aaa, bBb, 111, @@@.</div>
          <div *ngIf="!formControls.passwordInput.errors.minlength && !formControls.passwordInput.errors.maxlength &&
            !formControls.passwordInput.errors.pattern && !formControls.passwordInput.errors.repeatingChars &&
            formControls.passwordInput.errors.consecutiveChars">
            Your new password must not contain more than 2 consecutive characters in a row - e.g. aBc, CbA, 123 or 321.</div>
          <div *ngIf="!formControls.passwordInput.errors.minlength && !formControls.passwordInput.errors.maxlength &&
            !formControls.passwordInput.errors.pattern && !formControls.passwordInput.errors.repeatingChars &&
            !formControls.passwordInput.errors.consecutiveChars">
            <div *ngIf="formControls.passwordInput.errors.blacklistedPassword">
              Password must not contain any of the reserved words - e.g. SYS, LOG, TSO, etc. See Password Guidelines.</div>
            <div *ngIf="formControls.passwordInput.errors.containsMonth">
              Password must not contain a month abbreviation - e.g. Jan, Feb, Mar, etc.</div>
            <div *ngIf="formControls.passwordInput.errors.containsWeekDay">
              Password must not contain a weekday abbreviation - e.g. Mon, Tue, Wed, etc.</div>
            <div *ngIf="formControls.passwordInput.errors.containsChar">
              Password must not contain characters other than a-z, A-Z, 0-9, !@#$%^&*(){{'{'}}[~</div>
          </div>
        </div>
      </div>
      <div class="form-group form-label-group">
        <input id="confirmPasswordInput" formControlName="confirmPasswordInput" type="password" class="form-control"
               placeholder="Confirm New Password" [ngClass]="{ 'is-invalid': resetPasswordFormSubmitted &&
               (formControls.confirmPasswordInput.errors || resetPasswordForm.errors) }">
        <label for="confirmPasswordInput">Confirm New Password</label>
        <div *ngIf="resetPasswordFormSubmitted && (formControls.confirmPasswordInput.errors || resetPasswordForm.errors)"
             class="invalid-feedback">
          <div *ngIf="formControls.confirmPasswordInput.errors?.required">Please, confirm password.</div>
          <div *ngIf="!formControls.confirmPasswordInput.errors?.required && resetPasswordForm.errors?.passwordAreNotEqual">
            Password does not match. Please confirm your new password.</div>
        </div>
      </div>

      <div class="row pb-3">
        <div class="col-12 d-flex">
          <button type="submit" form="resetPasswordForm" id="createAccountButton"
                  class="btn rounded-pill bg-secondary text-white ml-auto px-4 py-2">
            <span class="font-weight-bold">Reset Password</span>
          </button>
        </div>
      </div>

    </form>

  </div>
</div>

